// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__24vJw","rootSmall":"AddTileButton_rootSmall__2LFri"};